var moment = module.exports = require("./moment-timezone");
moment.tz.load(require('./data/packed/latest.json'));



//////////////////
// WEBPACK FOOTER
// ./~/@mrmgomes/boleto-utils/~/moment-timezone/index.js
// module id = 549
// module chunks = 2